import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Button, Text, Badge } from "@fluentui/react-components";
import { ArrowExitRegular, BookOpenRegular } from "@fluentui/react-icons";
import { EmployeeSideNav } from "./EmployeeSideNav";
import { EmployeeDashboard } from "../views/Employee/EmployeeDashboard";
import { MyAbsences } from "../views/Employee/MyAbsences";
import { MyBadgeage } from "../views/Employee/MyBadgeage";
import { MyService } from "../views/Employee/MyService";
import { MyInfo } from "../views/Employee/MyInfo";
import { MyParcours } from "../views/Employee/MyParcours";
import { HelpContact } from "../views/Employee/HelpContact";
import { useAuth } from "../../context/AuthContext";
import { useRole } from "../../context/RoleContext";
import { FormationProvider, useFormation } from "../Formation/FormationContext";
import { TourGuide } from "../Formation/TourGuide";
import { FormationCenter } from "../Formation/FormationCenter";
import { RoleSwitcher } from "../common/RoleSwitcher";
const EmployeeLayoutInner = ({ onSwitchToRH }) => {
    const [activeView, setActiveView] = useState("dashboard");
    const [showFormation, setShowFormation] = useState(false);
    const { userName, userEmail } = useAuth();
    const { canAccessRH, role } = useRole();
    const { progressions, startTutoriel } = useFormation();
    // Première visite : lancer directement le tour de bienvenue
    useEffect(() => {
        if (progressions.length === 0 && !localStorage.getItem("salarie-onboarding-seen")) {
            const timer = setTimeout(() => {
                localStorage.setItem("salarie-onboarding-seen", "true");
                startTutoriel("salarie-bienvenue", "Salarie");
            }, 1500);
            return () => clearTimeout(timer);
        }
    }, [progressions.length, startTutoriel]);
    const renderView = () => {
        switch (activeView) {
            case "dashboard": return _jsx(EmployeeDashboard, {});
            case "absences": return _jsx(MyAbsences, {});
            case "badgeage": return _jsx(MyBadgeage, {});
            case "service": return _jsx(MyService, {});
            case "infos": return _jsx(MyInfo, {});
            case "parcours": return _jsx(MyParcours, {});
            case "aide": return _jsx(HelpContact, {});
        }
    };
    return (_jsxs("div", { style: { display: "flex", minHeight: "100vh", width: "100%" }, children: [_jsx(EmployeeSideNav, { activeView: activeView, onNavigate: setActiveView }), _jsxs("div", { style: { flex: 1, display: "flex", flexDirection: "column" }, children: [_jsxs("header", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "12px 32px",
                            borderBottom: "1px solid #e0e0e0",
                            backgroundColor: "#fff",
                        }, children: [_jsx(Text, { size: 400, weight: "semibold", style: { color: "#0066cc" }, children: "AVH - Mon espace salari\u00E9" }), _jsxs("div", { style: { display: "flex", alignItems: "center", gap: "12px" }, children: [_jsx(Button, { size: "small", appearance: "subtle", icon: _jsx(BookOpenRegular, {}), onClick: () => setShowFormation(true), title: "D\u00E9couvrir mon espace", children: "Aide" }), canAccessRH && onSwitchToRH && (_jsx(Button, { size: "small", appearance: "subtle", icon: _jsx(ArrowExitRegular, {}), onClick: onSwitchToRH, children: "Portail RH" })), _jsx(RoleSwitcher, {}), _jsx(Badge, { appearance: "outline", children: role }), _jsxs(Text, { size: 200, children: [userName, " (", userEmail, ")"] })] })] }), _jsx("main", { style: { flex: 1, padding: "24px 32px", overflow: "auto" }, children: showFormation ? (_jsx(FormationCenter, { portailType: "Salarie", onClose: () => setShowFormation(false), onNavigate: (view) => { setActiveView(view); setShowFormation(false); } })) : (renderView()) })] }), _jsx(TourGuide, {})] }));
};
export const EmployeeLayout = (props) => (_jsx(FormationProvider, { portailType: "Salarie", children: _jsx(EmployeeLayoutInner, { ...props }) }));
